import $ from 'jquery';
import { SCENE_EVENTS } from '../../MVC/Model';
import { SCENE_INTERACTION } from '../../../constants/scene';

class SendOfflineMessageModal {

  constructor({ model, socket, onOk }) {
    this.model = model;
    this.socket = socket;
    this.opened = false;
    this.onOk = onOk;

    this.template = $("#send_offline_message");
    this.btnOk = $("#send_offline_message #send-offline-message-button");
    this.btnCancel = this.template.find("#send-offline-message-button-cancel");

    this.btnCancel.on("click", () => {
      this.close();
    })
    this.btnOk.on("click", () => {
      this.onOk && this.onOk();
      this.close();
    })

    this.open = (socketUser) => {
      this.template.addClass("is-active");
    }
    this.close = () => {
      this.template.removeClass("is-active");
    }
  }

}

export default SendOfflineMessageModal;